import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { UserService } from '@core';
import { DigitsGroupingPipe } from '../pipes';

@Component({
    selector: 'lib-cart-old-price',
    templateUrl: './cart-old-price.component.html',
    styleUrls: ['./cart-old-price.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, DigitsGroupingPipe]
})
export class CartOldPriceComponent {
  readonly price = input<number | null>();
  readonly points = input<number>();

  readonly inline = input<boolean>();

  protected readonly canRedeemPoints = inject(UserService).canRedeemPoints;
}
